import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { startsWith, __ } from 'ramda';

const AdministrativeNavigation = ({ location, title, routes, isAuthenticated, isAdministrator }) => {
  const isRouteActive = startsWith(__, location.pathname);
  const isAdministrationMenuOpen = routes
    .map(route => isRouteActive(route.url))
    .reduce((match, carry) => match || carry, false);

  const [isOpen, setIsOpen] = useState(isAdministrationMenuOpen);

  const onClick = () => {
    setIsOpen(!isOpen);
  };
  
  if (!isAuthenticated  && !isAdministrator) {
    return null;
  }

  return (
    <React.Fragment>
      <li className="mt-4">
        <span className="block font-serif font-black text-3xl hover:text-gray-600 cursor-pointer" onClick={onClick}>{ title }</span>
        {
          isOpen && <ul className="text-center mb-12">
            {
              routes.map(({ url, label }) => <li key={url}>
                <Link to={url} className={`block mt-4 text-xl hover:text-gray-600 ${isRouteActive(url) ? 'font-bold' : ''}`}>{ label }</Link>
              </li> )
            }
          </ul>
        }
      </li>
    </React.Fragment>
  )
};

AdministrativeNavigation.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  title: PropTypes.string,
};

AdministrativeNavigation.defaultProps = {
  title: 'Amministrazione',
};

export default AdministrativeNavigation;
